module.exports = __webpack_public_path__ + "img/Affiliate-white.1039a38.svg";